import React, { Component } from 'react';
import AppBar from 'material-ui/AppBar';
import Grid from 'material-ui/Grid';
import Divider from 'material-ui/Divider';
import Typography from 'material-ui/Typography';
import {Link} from 'react-router-dom';
import basePath from '../../utils/basePath';
import LocalPhone from 'react-icons/lib/md/local-phone';
import Contacts from 'react-icons/lib/md/contacts';
import LocalPostOffice from 'react-icons/lib/md/local-post-office';
import Location from 'react-icons/lib/md/location-on';

export class Footer extends Component {

  render() {
    
    return (
      <div>
        <div>
          <AppBar position="static" color="default" className="footer_wrapper">
            <Grid container className="footer_container">
              <Grid item md={4} sm={12} xs={12} className="footer_division"> 
                <Typography className="footer_division_heading">Discover</Typography>
                <Divider className="footer_divider"/>
                <Typography><Link to={basePath``}>Home</Link></Typography> 
                <Typography><Link to={basePath`products`}>Products</Link></Typography> 
                <Typography><Link to={basePath`aboutus`}>About Us</Link></Typography>
                <Typography><Link to={basePath`contactus`}>Contact Us</Link></Typography>
              </Grid>
              <Grid item md={4} sm={12} xs={12} className="footer_division"> 
                <Typography><span><Location size={25}/></span>Reach Us</Typography>
                <Divider className="footer_divider"/>
                <Typography><a href="https://www.google.co.in/maps/place/Procut+Engineering/@23.0241663,72.6650305,188m/data=!3m1!1e3!4m5!3m4!1s0x395e87aa54c928a1:0x813246a90f5f8c1c!8m2!3d23.024191!4d72.665634?hl=en" target="_blank" rel="noopener noreferrer">Procut Engineering</a></Typography>
                <Typography>No.73, Girivar Globe Est.,</Typography>
                <Typography>Opp. Madhuram Est., Beside S.P. Ring Road,</Typography>
                <Typography>Kathawada, Ahmedabad-382430</Typography>
                <Typography>Gujarat, India.</Typography>
              </Grid>
              <Grid item md={4} sm={12} xs={12} className="footer_division"> 
                <Typography className="footer_division_heading">Contact</Typography>
                <Divider className="footer_divider"/>
                <Typography className="footer-text"><span><Contacts size={25}/></span>Office: <a href="tel:079-29292606">079-29292606</a></Typography>
                <Typography className="footer-text"><span><LocalPhone size={25}/></span>Mayur Patel: <a href="tel:919824738511">+91 9824738511</a></Typography>
                <Typography className="footer-text"><span><LocalPostOffice size={25}/></span><a href="https://mail.google.com/mail/?view=cm&fs=1&to=procutengineering@gmail.com" target="_blank" rel="noopener noreferrer">procutengineering@gmail.com</a></Typography>
              </Grid>
            </Grid>
            <Divider className="footer_container_devider"/>
            <Grid container className="footer_lower">
              <Grid item md={6} xs={12} className="footer_copyright">
              <Typography>Copyright © 2018 Procut Engineering. All Rights Reserved.</Typography>
              </Grid>
              <Grid item md={6} xs={12} className="footer_developer">
              <Typography>Develop By: <a href="https://www.facebook.com/stdeveloper/" target="_blank" rel="noopener noreferrer">S & T Developer</a></Typography>
              </Grid>
            </Grid>
          </AppBar>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/commons/ui/components/Footer.js